import { Component } from '@angular/core';

@Component({
  selector: 'app-image-pdf-content',
  imports: [],
  templateUrl: './image-pdf-content.component.html',
  styleUrl: './image-pdf-content.component.css'
})
export class ImagePdfContentComponent {

}
